// Login.js
// Form Input refs: https://stackoverflow.com/a/65885351

import React, { useEffect, useRef, useState } from "react";
import { Image, StyleSheet, Text, TouchableOpacity, View } from "react-native";
import Button from "components/Partials/Buttons";
import TextInputRef from "components/Partials/TextInputRef";
import formRefs from "components/helpers/formrefs";
import LogoIcon from "components/assets/logo.png";
import { ScreenLoading } from "components/Partials/Status";
import { triggerAlert } from "components/Partials/AlertModal";

const Login = () => {

  // const _loggedinUser = window.main.lib.getUserProfile();
  // const isLoginInit = useRef(false);
  // if (!isLoginInit.current) {
  //   isLoginInit.current = true;
  //   if (!!_loggedinUser && !!_loggedinUser.user_id) {
  //     window.main.lib.setCurrentView("/");
  //   }
  // }

  const [isScreenLoading, setIsScreenLoading] = useState(false);
  const loginFormRefs = useRef(new formRefs());

  const onSubmit = async () => {
    const formData = loginFormRefs.current.getAll();
    if (!("username" in formData) || !formData.username.trim()) {
      triggerAlert({
        show: true,
        title: "Login Email is required",
        message: "Please enter your user email to login.",
        onConfirmPressed: async () => {
          // Close this modal
          triggerAlert();
          // Re-focus the input
          // loginFormRefs.current.getRef("username").current.focus();
        },
      });
      return false;
    }
    if (!("password" in formData) || !(formData.password) || formData.password.trim().length < 8) {
      triggerAlert({
        show: true,
        title: "Password is required",
        message: "Please enter your password to login.",
        onConfirmPressed: async () => {
          // Close this modal
          triggerAlert();
          // Re-focus the input
          // loginFormRefs.current.getRef("password").current.focus();
        },
      });
      return false;
    }
    // Submit
    try {
      setIsScreenLoading(true);
      const postData = formData;
      // postData.remember = true;
      const login_resp = await window.main.axios.post(window.main.api.login, postData);
      if (!!login_resp.data?.loggedin) {
        const profile_resp = await window.main.axios.get(window.main.api.session);
        window.main.lib.setUserProfile(profile_resp?.data || {});
        window.main.lib.setTempIsLoggedin(true);
        window.main.lib.setTempIsSessionChecked(true);
        window.main.lib.triggerMainState();
        window.main.lib.setCurrentView("home");
        window.main.lib.setLoadingState(false);
        return;
      } else {
        return window.setTimeout(() => {
          triggerAlert({
            show: true,
            title: "Oops!",
            message: (login_resp.data?.error || "Invalid login. Please try again."),
            showConfirmButton: true,
            confirmText: "Ok",
            onConfirmPressed: () => {
              triggerAlert();
            },
          });
        },1);
      }
    } catch (err) {
      // Non-200 response...
      console.log("API response error:", err);
      // Non-200 response...
      setIsScreenLoading(false);
      let errMsg = window.main.lib.parseErrorMessage(err);
      if (!errMsg || typeof(errMsg)!=="string") {
        errMsg = "An error occurred. Please try again."
      }
      triggerAlert({
        show: true,
        title: "Oops!",
        message: errMsg,
        showConfirmButton: true,
        confirmText: "Ok",
        onConfirmPressed: () => {
          triggerAlert();
        },
      });
    }
  };

  const onKeyPressEnterSubmit = (e)=>{
    if(e.key==="Enter") {
      onSubmit();
    }
  };

  const _username_ref = useRef();
  const _password_ref = useRef();

  useEffect(()=>{
    window.main.lib.setLoadingState(false);
    // ⬇ This helps the web password managers work.
    _username_ref.current.name = "username";
    _password_ref.current.name = "password";
  },[]);

  const styles = StyleSheet.create(window.main.theme.externalUserPagesStyles);

  // LoginForm
  return (
    <View style={styles.container}>
      <View style={{...styles.wrapper,flexDirection:"column",alignItems:"center"}}>
        <View style={styles.headerRow}>
          <Image nativeID={"brand_logo"} style={{...styles.headerLogo,marginRight:6}} source={LogoIcon} resizeMode={"cover"} accessibilityLabel={"VetManaged Logo"} />
          <Text nativeID={"app_title"} style={{...styles.headerTitle,whiteSpace:"nowrap"}}> {process.env.REACT_APP_APPTITLE}</Text>
        </View>
        <View style={styles.headerRow}>
          <Text style={ styles.headerTitle }>Administrator Login</Text>
        </View>
        <TextInputRef ref={_username_ref} nativeID="input_username" formrefs={loginFormRefs.current} datakey={"username"} textValue={""} placeholder="Username..." style={{...window.main.theme.textInputLarge,width:300}} clearButtonMode="always" textContentType="username" onKeyPress={onKeyPressEnterSubmit} autoFocus={true} />

        <TextInputRef ref={_password_ref} nativeID="input_password" formrefs={loginFormRefs.current} datakey={"password"} textValue={(process.env.REACT_APP_DEV_PWORD||"")} placeholder="Password..." style={{...window.main.theme.textInputLarge,width:300,marginBottom:20}} clearButtonMode="always" secureTextEntry={true} onKeyPress={onKeyPressEnterSubmit} />

        <Button nativeID="button_login" type="primary" ficon="log-in" text=" Login" onpress={onSubmit} style={{width:260}} />

        <ScreenLoading loadingState={isScreenLoading} style={{paddingTop:100}} />

      </View>
    </View>
  );
};

export default Login;
